import { FundNoteCollege, SystemCode } from 'src/settings/settings';

import {
  checkFoundFeaturesByCode,
  DISABLE_ON_MATCH,
  isTransactionRestrictedForFundingBank,
  updateFundNote,
} from '../shared/shared-fund-notes-utility';

/**
 * Fund notes that are used in MFEX to 529 and 529-contribute
 * @param {*} fund
 * @param {*} personalData
 */
export function updateSharedCollegeFundNotes(fund) {
  // Address Undeliverable
  updateFundNote(
    fund,
    checkFoundFeaturesByCode(fund, SystemCode.STOP_MAIL_ID) &&
      !fund.addressChangedSameDay,
    FundNoteCollege.ADDRESS_UNDELIVERABLE,
    DISABLE_ON_MATCH
  );

  // Don't disable fund if pending transactions exist
  updateFundNote(fund, fund.hasPendingTransaction, FundNoteCollege.PENDING);
  updateFundNote(
    fund,
    checkFoundFeaturesByCode(fund, SystemCode.STOP_PURCHASE) ||
      fund['529FundMerged'],
    FundNoteCollege.STOP_PURCHASE,
    DISABLE_ON_MATCH
  );
}

export function updateCollegeFundNotesForFund(
  fund,
  personalData,
  selectedBankAgreementMap
) {
  const { associatedPurchaseRestrictedLookup } = selectedBankAgreementMap;

  updateFundNote(
    fund,
    isTransactionRestrictedForFundingBank(fund, selectedBankAgreementMap),
    FundNoteCollege.CANNOT_LINK_BANK,
    DISABLE_ON_MATCH
  );
  updateFundNote(
    fund,
    associatedPurchaseRestrictedLookup[fund.uniqueKey],
    FundNoteCollege.ONLINE_PURCHASE_RESTRICTED,
    DISABLE_ON_MATCH
  );

  updateSharedCollegeFundNotes(fund);
}

export const isAlaska529 = (fundVal) => {
  return fundVal.productType === 'Alaska529';
};
